import type { SidebarEntry } from "shared/constants";
import { useDrawerStack } from "./useDrawerStack";

export const useSidebar = () => {
  const {
    pushSidebar,
    replaceSidebar,
    popSidebar,
    closeAllSidebars,
    closeSidebarAndAbove,
    stack,
    depth,
    topmost,
    isTopmost,
    isInStack,
    getStackIndex,
  } = useDrawerStack();

  /**
   * Opens a sidebar, replacing the entire stack with a single drawer.
   * Backwards-compatible with the previous single-sidebar behavior.
   */
  const openSidebar = (
    sidebarConfig: SidebarEntry,
    id?: string | number,
    extraParams?: Record<string, string | number>,
  ) => {
    return replaceSidebar(sidebarConfig, id, extraParams);
  };

  return {
    openSidebar,
    pushSidebar,
    popSidebar,
    closeAllSidebars,
    closeSidebarAndAbove,
    stack,
    depth,
    topmost,
    isTopmost,
    isInStack,
    getStackIndex,
  };
};
